import api from './api';

/**
 * Adresse structurée (juridiction) persistée sur le profil CLIENT.
 * Complémentaire aux coordonnées GPS : city/province placent le client
 * sur les cartes et alimentent l'isolation régionale des administrateurs
 * avant même qu'un point GPS ne soit épinglé.
 */
export interface CustomerJurisdictionAddress {
  city?: string;
  province?: string;
  street?: string;
  commune?: string;
  country?: string;
}

/**
 * Service pour la partie CLIENT (customer-service) accessible via le gateway
 * (`${VITE_API_URL}` == `.../land/api/v1`). Réutilise le même client `api`
 * (auth Bearer, rate-limit, monitoring) que les autres services.
 */
class CustomerApiService {
  private baseUrl = '/customers';

  /**
   * Persiste la juridiction (Ville/Province) sur Customer.address via
   * PUT /customers/:customerId. Le backend MERGE dans l'adresse existante
   * (ne pas écraser street/commune/country) et émet l'event customer.updated.
   */
  async updateJurisdiction(
    customerId: string,
    address: CustomerJurisdictionAddress,
  ): Promise<void> {
    await api.put(`${this.baseUrl}/${customerId}`, { address });
  }
}

export const customerApiService = new CustomerApiService();
export default customerApiService;
